"use client";
import type { AlgoliaDialogProps } from "@/components/AlgoliaDialog";
import type { ActiveOrganizationMembership } from "@/types/active-membership";
import type { OrganizationMemberActor } from "@/types/actor";
import type { OrganizationClient } from "@/utils/organization-client";
import { createContext } from "react";

export type { ActiveOrganizationMembership };

export type OrganizationLayoutContext = {
  actor: OrganizationMemberActor;
  organization: OrganizationClient;
  activeOrganizationMembership: ActiveOrganizationMembership;
  openSearch: (props?: Pick<AlgoliaDialogProps, "tabs" | "onSelect" | "purpose">) => void;
  dismissSearch: () => void;
};

const LayoutContext = createContext<OrganizationLayoutContext>(null!);

export default LayoutContext;
